import React from "react";
import { useSelector } from "react-redux";
import { Container } from "react-bootstrap";
import HelmetWrapper from "../../HelmetWrapper";
import { selectUser } from "../../components/auth/auth.selector";
import "../../styles/fitness-center/fitness-center.css";
import FitnessCenterLanding from "../../components/fitness-center/FitnessCenterLanding";

const FitnessCenter = () => {
  const userInfoData = useSelector(selectUser);

  return (
    <HelmetWrapper title="WTF: Fitness Canters">
      <Container className="bg-cloud-k px-50px gobal-container" fluid>
        <FitnessCenterLanding userInfoData={userInfoData} />
      </Container>
    </HelmetWrapper>
  );
};

export default FitnessCenter;
